import Button from '@/components/ui/button-old';
import { Pin } from 'lucide-react';
import { useState, useEffect, useRef } from 'react';
import { useWishlist } from '@/data/wishlist';
import WishlistDropdown from './wishlist-dropdown';
import { eventEmitter } from '@/lib/events';

export default function WishlistButton({ className }: { className?: string }) {
  const [isOpen, setIsOpen] = useState(false);
  const { wishlists, isLoading } = useWishlist();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    // Listen for wishlist:added events
    const handleWishlistAdded = () => {
      setIsOpen(true);
    };

    eventEmitter.on('wishlist:added', handleWishlistAdded);

    return () => {
      eventEmitter.off('wishlist:added', handleWishlistAdded);
    };
  }, []);

  return (
    <div className="relative flex items-center justify-center" ref={containerRef}>
      <Button
        variant="icon"
        aria-label="Wishlist"
        onClick={() => setIsOpen(!isOpen)}
        className={className}
      >
        <span className="relative flex items-center">
          <Pin className="h-5 w-5 rotate-45 !text-default-600 dark:!text-default-500" />
          {wishlists.length > 0 && (
            <span className="absolute -top-2.5 -right-2.5 flex h-4 w-4 items-center justify-center rounded-full bg-brand text-[10px] text-white">
              {wishlists.length}
            </span>
          )}
        </span>
      </Button>

      {isOpen && (
        <WishlistDropdown 
          wishlists={wishlists} 
          isLoading={isLoading}
          onClose={() => setIsOpen(false)}
        />
      )}
    </div>
  );
} 